import { useEffect } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';

// project import
import { APP_DEFAULT_PATH } from 'config';
import useAuth from 'hooks/useAuth';

// types
import { GuardProps } from 'types/auth';

// ==============================|| GUEST GUARD ||============================== //

export default function GuestGuard({ children }: GuardProps) {
  const { isLoggedIn } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (isLoggedIn) {
      const redirectSearchParam = searchParams.get('redirect');
      console.log(redirectSearchParam);
      const targetPage = location?.state?.from
        ? location?.state?.from
        : redirectSearchParam?.startsWith('/')
          ? redirectSearchParam
          : APP_DEFAULT_PATH;

      navigate(targetPage, {
        state: {
          from: '',
        },
        replace: true,
      });
    }
  }, [isLoggedIn, navigate, location, searchParams]);

  return children;
}
